import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=0492c1a2&scoped=true&"
import script from "./gateway.vue?vue&type=script&lang=js&"
export * from "./gateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492c1a2",
  null
  
)

export default component.exports